<template>
	<div class="page-main">
		<nav-bar title="二维码" :border="false" :left-arrow="true" @click-left="pageBack"></nav-bar>

		<div class="card-box">
			<!-- maintain_star.png -->

			<img src="~@/assets/ic_fresh_new_logo.png" class="logo" />
			<div class="qrcode">
				<img class="img" :src="qrcode" />
				<div class="p">二维码每30秒自动更新</div>
			</div>


			<div class="bottom">
				<img class="img" src="~@/assets/member_rewards_bg.png" />
				<div class="p">使用星礼卡，同步支付积星星</div>
			</div>


		</div>

	</div>
</template>

<script>
	import {
		navBar
	} from "vant";
	import {
		getQr
	} from "@/api";
	export default {
		data() {
			return {
				qrcode: null
			}
		},
		created() {
			this.getQrcode();
			this.time = setInterval(this.getQrcode, 30000);
		},
		methods: {
			getQrcode() {
				getQr().then(d => {
					this.qrcode = "data:image/png;base64," + d.data;
				})
			},
			pageBack() {
				window.history.back();
			}
		},
		components: {
			navBar
		},
		beforeDestroy() {
			if (this.time) {
				clientInformation(this.time);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.page-main {
		background: #666;
		min-height: 100vh;

		::v-deep .van-nav-bar {
			background: transparent;

			.van-nav-bar__title,
			.van-nav-bar__left .van-icon {
				color: #fff !important;
			}

		}

		.card-box {
			background: #fff;
			margin: 30px;
			border-radius: 16px;
			padding-top: 60px;
			position: relative;

			&::before,
			&::after {
				content: "";
				position: absolute;
				width: 50px;
				height: 50px;
				border-radius: 50%;
				background: #666;
				top: 692px;
			}

			&::before {
				right: -25px;
			}

			&::after {
				left: -25px;
			}

			.logo {
				width: 100px;
				height: 100px;
				margin: auto;
			}

			img {
				display: block;
			}

			.qrcode {
				padding: 50px 0 40px;

				.img {
					width: 400px;
					height: 400px;
					margin: auto;
					margin-bottom: 30px;
				}

				.p {
					font-size: 24px;
					text-align: center;
					color: #666;
				}
			}

			.bottom {
				padding: 30px 0 50px;
				border-top: 1px dashed #ddd;

				img {
					width: 60%;
					margin: auto;
					margin-bottom: 20px;
				}

				.p {
					text-align: center;
					font-size: 24px;
				}
			}
		}
	}
</style>